import { useState, type PropsWithChildren } from 'react'
import { Tooltip, Typography } from '@mui/material'
import { useTruncationTooltip } from 'lib/hooks/useTruncationTooltip/useTruncationTooltip'

export const NoWrapMessageContent: React.FC<PropsWithChildren> = ({ children }) => {
  const [element, setElement] = useState<HTMLElement | null>(null)
  const { isTooltipOpen, isTruncated, handleTooltipOpen, handleTooltipClose } = useTruncationTooltip(element)

  return (
    <Tooltip
      title={children}
      open={isTruncated && isTooltipOpen}
      onOpen={handleTooltipOpen}
      onClose={handleTooltipClose}
    >
      <Typography
        ref={setElement}
        component="div"
        variant="inherit"
        noWrap={true}
        tabIndex={isTruncated ? 0 : undefined}
        sx={{ width: 'fit-content', maxWidth: '100%' }}
      >
        {children}
      </Typography>
    </Tooltip>
  )
}
